class BuyNowButton extends HTMLElement {
  #abortController;
  #availabilityObserver;
  #button;

  connectedCallback() {
    this.#abortController = new AbortController();
    this.#button = this.querySelector('button');
    if (!this.#button) return;

    this.#button.addEventListener('click', this.#handleClick, { signal: this.#abortController.signal });

    const container = this.closest('.accelerated-checkout-block');
    if (container) {
      this.#availabilityObserver = new MutationObserver(this.#syncAvailability);
      this.#availabilityObserver.observe(container, { attributes: true, attributeFilter: ['hidden'] });
    }
    this.#syncAvailability();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#availabilityObserver?.disconnect();
  }

  #syncAvailability = () => {
    if (!this.#button || this.dataset.submitting === 'true') return;
    this.#button.disabled = Boolean(this.closest('.accelerated-checkout-block')?.hidden);
  };

  #handleClick = async () => {
    const productForm = this.closest('product-form-component');
    const form = productForm?.querySelector('form');
    if (!form || !this.#button || this.#button.disabled) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const errorElement = this.querySelector('[data-buy-now-error]');
    errorElement?.classList.add('hidden');
    if (errorElement) errorElement.textContent = '';

    this.dataset.submitting = 'true';
    this.#button.disabled = true;
    this.#button.setAttribute('aria-busy', 'true');
    let shouldReenable = true;

    try {
      const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });
      const payload = await response.json();
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Unable to proceed to checkout. Please try again.');
      }

      shouldReenable = false;
      window.location.assign(this.dataset.checkoutUrl || '/checkout');
    } catch (error) {
      if (errorElement) {
        errorElement.textContent = error instanceof Error ? error.message : String(error);
        errorElement.classList.remove('hidden');
      }
    } finally {
      if (shouldReenable && this.#button) {
        delete this.dataset.submitting;
        this.#button.disabled = false;
        this.#button.removeAttribute('aria-busy');
      }
    }
  };
}

if (!customElements.get('buy-now-button')) {
  customElements.define('buy-now-button', BuyNowButton);
}
